<template>
  <basic-container>
    <avue-crud :option="option" v-model="form" :data="data" ref="crud" :page.sync="page" @refresh-change="onLoad"
      @on-load="onLoad">
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList } from '../api/nursinghomeserviceitemlog.js';
export default {
  props: {
    row: {
      default: {},
    }
  },
  data() {
    return {
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            type: 'string',
            dataType: 'number',
            props: {
              label: 'name',
              value: 'id',
            },
            dicUrl: '/api/nursing/getNursinghome',
          },
          {
            label: '服务项目',
            prop: 'serviceItemName',
          },
          {
            label: '服务类型',
            prop: 'serviceType',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_service_type',
          },

          {
            label: '需求老人',
            prop: 'peopleName',
          },
          {
            label: '联系电话',
            prop: 'tel',
          },
          {
            label: '服务地点',
            prop: 'serviceAddress',
          },
          {
            label: '需求描述',
            prop: 'description',
          },

          {
            label: '服务人员',
            prop: 'servicePeopleName',
          },
          {
            label: '服务费用',
            prop: 'servicePrice',
          },
          {
            label: "服务开始时间",
            prop: "serviceStartTime",
          },
          {
            label: "服务结束时间",
            prop: "serviceEndTime",
          },
        ],
      },
      data: []
    };
  },

  methods: {
    onLoad() {
      this.loading = true;
      getList(
        Object.assign(
          {},
          {
            current: this.page.currentPage, size: this.page.pageSize, nursinghomeId: this.row.nursinghomeId, elderlyId: this.row.id
          }
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<style></style>
